<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <b-table
          :items="getSpecimenTypeAll"
          :fields="fields"
          striped
          bordered
          responsive
        >
          <template slot="action" slot-scope="data">
            <b-container fluid>
              <b-row align-h="center">
                <b-col cols="auto">
                  <fa-icon
                    :icon="['fas', 'edit']"
                    class="icon warning"
                    @click="openFieldModal(data.item.id)"
                  />
                  <!--                                <b-button variant="warning" @click="openFieldModal(data.item.id)">-->
                  <!--                                    แก้ไข-->
                  <!--                                </b-button>-->
                </b-col>
                <b-col cols="auto">
                  <fa-icon
                    :icon="['fas', 'trash']"
                    class="icon danger"
                    @click="openDeleteModal(data.item.id)"
                  />
                  <!--                                <b-button variant="danger" @click="openDeleteModal(data.item.id)">-->
                  <!--                                    ลบ-->
                  <!--                                </b-button>-->
                </b-col>
              </b-row>
            </b-container>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SpecimenType",
  data() {
    return {
      fields: [
        {
          name: "ชื่อ",
          key: "name",
        },
        {
          name: "ชื่อเรียก",
          key: "called_name",
        },
        {
          name: "Action",
          key: "action",
        },
      ],
      deleteSpecimenTypeIdSelected: null,
      specimentTypeInput: {
        id: null,
        name: null,
        called_name: null,
        test: [],
      },
    };
  },
  mounted() {
    this.setSpecimenTypeAll();
  },
  computed: {
    ...mapGetters({
      getSpecimenTypeAll: "Test/getSpecimenType",
    }),
  },
  methods: {
    ...mapActions({
      setSpecimenTypeAll: "Test/setSpecimenType",
    }),
    async openFieldModal(specimenTypeId = null) {
      const specimenTypeSelected = specimenTypeId
        ? this.getSpecimenTypeAll.find((test) => test.id === specimenTypeId)
        : null;
      if (specimenTypeSelected) {
        this.specimentTypeInput = {
          id: specimenTypeSelected.id,
          name: specimenTypeSelected.name,
          called_name: specimenTypeSelected.called_name,
          test: specimenTypeSelected.test,
        };
      }

      this.$refs["inputModal"].show();
    },
    openDeleteModal(specimenTypeId) {
      this.deleteSpecimenTypeIdSelected = specimenTypeId;
      this.$refs["confirmDelete"].show();
    },
  },
};
</script>

<style scoped></style>
